import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosMixTravel = {
    ...dadosAgenciaComum,
    id: 'mixtravel',
    nome: 'Mix Travel',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
